import { splitMessages } from '../../utils/dataCollection/namespacesValidations/mergeNamespaceStatus'
import type { NamespaceValidationStatus } from '../../utils/dataCollection/namespacesValidations/unusedPaddocks'
import type { Notice } from '../Notices/types'

export const tabStatusNotices = (namespace: string, status?: NamespaceValidationStatus): Notice[] =>
  splitMessages(status?.error ?? null).map((message, index) => ({
    id: `tab-status-${namespace}-${index}`,
    severity: status.disabled ? 'error' : 'warning',
    summary: message,
  }))
